import { render, staticRenderFns } from "./feedbackDisposalResultsDetail.vue?vue&type=template&id=5207f0ea&scoped=true"
import script from "./feedbackDisposalResultsDetail.vue?vue&type=script&lang=js"
export * from "./feedbackDisposalResultsDetail.vue?vue&type=script&lang=js"
import style0 from "./feedbackDisposalResultsDetail.vue?vue&type=style&index=0&id=5207f0ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207f0ea",
  null
  
)

export default component.exports